import { render, staticRenderFns } from "./logout.vue?vue&type=template&id=12f4fd78&scoped=true&"
import script from "./logout.vue?vue&type=script&lang=js&"
export * from "./logout.vue?vue&type=script&lang=js&"
import style0 from "./logout.vue?vue&type=style&index=0&id=12f4fd78&prod&scoped=true&lang=scss&"
import style1 from "./logout.vue?vue&type=style&index=1&id=12f4fd78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f4fd78",
  null
  
)

export default component.exports